var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stage",class:{ 'on' : _vm.isOpened }},[_c('div',{ref:"container",attrs:{"id":"stage"}}),_vm._v(" "),_c('a',{ref:"btClose",staticClass:"bt-close",class:{ 'on' : _vm.isOpened },on:{"click":this.destroy}},[_c('img',{attrs:{"src":"/assets/img/bt_close.png"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }